export default function download(href: string, filename: string) {
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.target = "_blank";
  a.dataset.downloadurl = [a.download, a.href].join(":");
  a.click();
}
